import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ContenuCtaVideo } from '@components/contenu-cta-video/models';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-contenu-cta-video',
  imports: [TitleComponent, ButtonComponent, VideoComponent],
  templateUrl: './contenu-cta-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContenuCtaVideoComponent extends AbstractDynamicComponent<ContenuCtaVideo> {}
